import * as React from 'react';
import { useSelector } from 'react-redux';

import { EFieldGroupName, EFieldName } from '../../../../types/field';
import { ECategory } from '../../../../types/category';
import { selectOfferFieldAvailable } from '../../../../selectors/offers';
import { FlatSaleFieldContainer } from './flatSale';
import { NewbuildingFlatSaleFieldContainer } from './newBuildingFlatSale';
import { EmptyField } from '../../../../components/Field/common';
import { useOfferContext } from '../../../../utils/offerContext';

export interface ITableFieldContainerProps {
  name: EFieldName;
  groupName: EFieldGroupName;
}

const TableFieldContainer: React.VFC<ITableFieldContainerProps> = ({ name, groupName }) => {
  const { id, category, published } = useOfferContext();
  const available = useSelector(selectOfferFieldAvailable(id, groupName, name));

  if (!available) {
    return <EmptyField published={published} />;
  }

  switch (category) {
    case ECategory.NewBuildingFlatSale:
      return <NewbuildingFlatSaleFieldContainer name={name} published={published} />;
    case ECategory.FlatSale:
      return <FlatSaleFieldContainer name={name} published={published} />;
    default:
      return <EmptyField published={published} />;
  }
};

const MemoizedTableFieldContainer = React.memo(TableFieldContainer);

export { MemoizedTableFieldContainer as TableFieldContainer };
